import React, { useState, useEffect } from 'react';
import {
  Grid,
  List,
  Card,
  CardHeader,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Checkbox,
  Divider,
  ListItemAvatar,
  Avatar,
  TextField,
  Box,
} from '@mui/material';
import { stringAvatar } from '../common/util';

const SelectAllTransferList = ({ left, setLeft, right, setRight, isStudent }) => {
  const [filteredLeft, setFilteredLeft] = useState(left);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    setFilteredLeft(left);
  }, [left]);

  const handleToggle = (value, isLeft) => () => {
    if (isLeft) {
      setLeft(left.filter(item => item.id !== value.id));
      setRight([...right, value]);
      setSearchQuery('');
      setFilteredLeft(left.filter(item => item.id !== value.id));
    } else {
      setRight(right.filter(item => item.id !== value.id));
      setLeft([...left, value]);
    }
  };

  const handleQuery = (event) => {
    const query = event.target.value.toLowerCase();
    setSearchQuery(query);
    const filtered = left.filter(row => query === '' || row.displayName.toLowerCase().includes(query));
    setFilteredLeft(filtered);
  };

  const renderAvatar = (value) => {
    return value.photoUrl || value.role !== "student" ? (
      <Avatar src={value.photoUrl} />
    ) : (
      <Avatar {...stringAvatar(value.displayName)} />
    );
  };

  const customList = (title, items, isLeft) => (
    <Card sx={{ width: '100%', minHeight: '500px', maxHeight: '500px' }}>
      <CardHeader
        sx={{ px: 2, py: 1 }}
        title={
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box>{title}</Box>
            {isLeft && (
              <TextField
                sx={{ ml: 2, flexGrow: 1 }}
                label="Search Name"
                size="small"
                variant="outlined"
                value={searchQuery}
                onChange={handleQuery}
              />
            )}
          </Box>
        }
      />
      <Divider />
      <List
        sx={{
          width: '100%',
          minHeight: '400px',
          maxHeight: '400px',
          bgcolor: 'background.paper',
          overflow: 'auto',
        }}
        dense
        component="div"
        role="list"
      >
        {items.map((value) => {
          const labelId = `transfer-list-all-item-${value.id}-label`;

          return (
            <ListItemButton
              key={value.id}
              role="listitem"
              onClick={handleToggle(value, isLeft)}
            >
              <ListItemIcon>
                <Checkbox
                  checked={!isLeft}
                  tabIndex={-1}
                  inputProps={{ 'aria-labelledby': labelId }}
                />
              </ListItemIcon>
              <ListItemAvatar>
                {renderAvatar(value)}
              </ListItemAvatar>
              <ListItemText
                id={labelId}
                primary={isStudent ? `${value.displayName} - ${value.email}` : `${value.displayName} (${value.grade}) - ${value.email}`}
              />
            </ListItemButton>
          );
        })}
      </List>
    </Card>
  );

  return (
    <Grid container spacing={2} justifyContent="center" alignItems="center">
      <Grid item xs={6}>
        {customList(isStudent ? 'Unassigned Teachers' : 'Unassigned Students', filteredLeft, true)}
      </Grid>
      <Grid item xs={6}>
        {customList(isStudent ? 'Selected Teachers' : 'Selected Students', right, false)}
      </Grid>
    </Grid>
  );
};

export default SelectAllTransferList;
